/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import { commonConstants } from '../constants';
const defaultPlanInfo = {};

function planInfo(state = defaultPlanInfo, action) {
  switch (action.type) {
    case commonConstants.PLAN_INFO_FETCH_SUCCESS:
      return action.planInfo;
    case commonConstants.PLAN_INFO_INITIAL:
      return action.planInfo;
    case commonConstants.PLAN_INFO_RESET:
      return defaultPlanInfo;
    default:
      return state;
  }
}

export { planInfo };
